import { render, staticRenderFns } from "./userApproval.vue?vue&type=template&id=c1c87eb8&scoped=true&"
import script from "./userApproval.vue?vue&type=script&lang=js&"
export * from "./userApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c87eb8",
  null
  
)

export default component.exports